module.exports = __webpack_public_path__ + "static/media/ic_more_tool_primary.c0950926.svg";